// removed by extract-text-webpack-plugin
module.exports = {"verify-info":"verify-info__1l7Bu","info-text":"info-text__1lC5d","less":"less__3kHH2","more":"more__1vRpl","mail-to":"mail-to__jRwjD","tel":"tel__F4dzH","important-text":"important-text__2DjvX","orange":"orange__3alFK","read-more":"read-more__bBxQB","kycBlock":"kycBlock__ThGIH"};


//////////////////
// WEBPACK FOOTER
// ./styles/common/verifyInfo.scss
// module id = 1223
// module chunks = 68